import { FC } from 'react';
import classNames from 'classnames';
type ScoreToParProps = {
  /**
   * The size of the component.
   */
  size?: 'default' | 'large';
  /**
   * The score to display.
   */
  score?: number;
  /**
   * Show square style variant.
   */
  square?: boolean;
};

/**
 * ScoreToPar component displays the score to par for a round.
 */
export const ScoreToPar: FC<ScoreToParProps> = ({
  size = 'default',
  score,
  square
}) => {
  if (typeof score === 'number') {
    const className = classNames('text-center inline-flex justify-center text-white print:w-auto print:h-auto print:bg-transparent print:text-primary', {
      'w-8 text-xs': size === 'default',
      'w-10 text-base': size === 'large',
      'bg-bogey-blue': score === 0,
      'bg-birdie-red': score < 0,
      'bg-over-par-gray': score > 0,
      'rounded-full aspect-square': !square,
      'rounded py-1': square
    });
    if (score > 10000) {
      return <div className={className}>
          <div className="self-center">N/A</div>
        </div>;
    }
    return <div className={className}>
        <div className="self-center">{score === 0 ? 'E' : `${score > 0 ? '+' : ''}${score}`}</div>
      </div>;
  } else {
    return '-';
  }
};